import {TableColumn} from "../../../interfaces/table/table-column";
import {TableColumnType} from "../../../enums/table-column-type";
import {TemplateRef} from "@angular/core";

export enum ServiceRequestsTableColumn {
  ServiceRequestNumber = 'ServiceRequestNumber',
  Status = 'ServiceRequestStatusName',
  Assets = 'asset',
  LocationName = 'LocationName',
  CreatedFullName = 'CreatedFullName',
  CreatedDate = 'CreatedDate'
}

export function constructColumns(
  serviceRequestNumberAssetColumnTmp: TemplateRef<any>,
  assetColumnTmp: TemplateRef<any>
): TableColumn[] {
  return [
    {
      columnId: ServiceRequestsTableColumn.ServiceRequestNumber,
      header: 'SR Number',
      type: TableColumnType.Template,
      template: serviceRequestNumberAssetColumnTmp,
      sortable: true
    },
    {
      columnId: ServiceRequestsTableColumn.Status,
      header: 'Status',
      type: TableColumnType.Tag,
      sortable: true
    },
    {
      columnId: ServiceRequestsTableColumn.Assets,
      header: 'Asset(s)',
      type: TableColumnType.Template,
      template: assetColumnTmp,
      sortable: true
    },
    {
      columnId: ServiceRequestsTableColumn.LocationName,
      header: 'Location',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: ServiceRequestsTableColumn.CreatedFullName,
      header: 'Created By',
      type: TableColumnType.Text,
      sortable: true
    },
    {
      columnId: ServiceRequestsTableColumn.CreatedDate,
      header: 'Created Date',
      type: TableColumnType.Text,
      sortable: true
    }
  ];
}
